import { Box, Flex, Image, Stack, Text, useToast } from '@chakra-ui/react';
import React, { useState } from 'react';
import InputNames from '../../custom-components/text/InputNames';
import { useGetProfileMenu, useSaveToClipBoard } from '../../../hooks';
import { useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeLowVision } from '@fortawesome/free-solid-svg-icons';
import Input from '../../custom-components/Inputs/Input';
import { useError } from '../../../error-provider/ErrorProvider';
import { GetMe } from '../../../graphql/queries/GetMe';
import { useQuery } from '@apollo/client';
import copyIcon from '../../../assets/icons/copy.svg';
import ZaraButton from '../../custom-components/buttons/Button';
import { PATHS } from '../../../router/routes';

const ApiKeyComponent = () => {
    const [isHideKey, setIsHideKey] = useState(true);
    const router = useNavigate();
    const showError = useError();
    const toast = useToast();
    const location = useLocation();
    const { pathname } = location;
    const profileMenu = useGetProfileMenu();

    const { data } = useQuery(GetMe, {
        onError(error) {
            showError(undefined, error);
        },
    });

    const aPIKey = data?.getMe?.key ?? '';

    const saveInClipBoard = useSaveToClipBoard(aPIKey, toast, 'API key');

    const checkCurrentPage = (page) => {
        if (pathname === page) {
            return true;
        } else {
            return false;
        }
    };

    return (
        <>
            <Flex
                minH='560px'
                boxShadow=' 0px 1px 3px 0px #0000001A'
                mt='6'
                w='100%'
                css={{
                    '@media only screen and (max-width: 920px)': {
                        marginLeft: '0px',
                    },
                    '@media only screen and (min-width: 500px)': {
                        display: 'flex',
                    },
                    '@media only screen and (max-width: 450px)': {
                        display: 'none',
                    },
                    '@media only screen and (max-height: 450px)': {
                        marginBottom: '100px',
                    },
                }}
                border='1px solid #E2E8F0'
                borderRadius='4px'
            >
                <Stack p='10px' spacing='10px' w='278px' borderRight='1px solid #E2E8F0'>
                    {profileMenu.map((menuItem) => (
                        <Box
                            onClick={() => {
                                router(menuItem.path);
                            }}
                            cursor='pointer'
                            css={{
                                ':hover': {
                                    background: checkCurrentPage(menuItem.path) ? '#F7FAFC' : 'white',
                                    border: checkCurrentPage(menuItem.path) ? '1px solid white' : '1px solid #E2E8F0',
                                },
                                ':active': {
                                    background: checkCurrentPage(menuItem.path) ? '#F7FAFC' : 'white',
                                },
                            }}
                            bg={checkCurrentPage(menuItem.path) ? '#F7FAFC' : 'white'}
                            textAlign='left'
                            p='6px 12px'
                            border='1px solid white'
                            key={menuItem.name}
                        >
                            <Text fontSize='16px' lineHeight='28px' fontWeight='400'>
                                {menuItem.name}
                            </Text>
                        </Box>
                    ))}
                </Stack>
                <Box h='100%' w='100%'>
                    <Stack spacing='3' p='20px'>
                        <Box>
                            <InputNames>API Key</InputNames>
                            <Flex alignItems='center'>
                                <Input
                                    value={aPIKey}
                                    rightIcon={
                                        <FontAwesomeIcon
                                            cursor='pointer'
                                            height={20}
                                            width={20}
                                            onClick={() => setIsHideKey((prevState) => !prevState)}
                                            icon={isHideKey ? faEye : faEyeLowVision}
                                        />
                                    }
                                    type={isHideKey ? 'password' : 'text'}
                                    readOnly
                                />
                                <Image
                                    onClick={saveInClipBoard}
                                    cursor='pointer'
                                    ml='20px'
                                    w='24px'
                                    h='24px'
                                    src={copyIcon}
                                />
                            </Flex>
                        </Box>
                    </Stack>
                </Box>
            </Flex>

            {/*Mobile version */}
            <Box
                css={{
                    '@media only screen and (max-width: 450px)': {
                        display: 'block',
                    },
                    '@media only screen and (min-width: 500px)': {
                        display: 'none',
                    },
                }}
                mt='70px'
            >
                <Stack spacing='3'>
                    <Box>
                        <InputNames>API Key</InputNames>
                        <Input
                            onClick={saveInClipBoard}
                            value={aPIKey}
                            rightIcon={
                                <FontAwesomeIcon
                                    cursor='pointer'
                                    height={20}
                                    width={20}
                                    onClick={() => setIsHideKey((prevState) => !prevState)}
                                    icon={isHideKey ? faEye : faEyeLowVision}
                                />
                            }
                            type={isHideKey ? 'password' : 'text'}
                            readOnly
                        />
                    </Box>
                </Stack>

                <Box mt='12px'>
                    <ZaraButton variant='secondary' w='100%' onClick={() => router(PATHS.PROFILE_INFO)}>
                        Back
                    </ZaraButton>
                </Box>
            </Box>
        </>
    );
};

export default ApiKeyComponent;
